import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import { contentStyles, h2, h5 } from '@helpers/typography';
import { cardWidth } from '@stories/Components/CardGrid/CardGrid.styles';
import { ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled.div `
  ${cardWidth};

  --contentColour: ${brand.global.white};
  --bgColour: ${brand.blue.navy};
  --stepColour: ${brand.green.default};

  display: flex;
  flex-direction: column;
  border-radius: 20px 20px 20px 0;
  color: var(--contentColour);
  background: var(--bgColour);
  overflow: hidden;
  text-decoration: none;
  padding-bottom: ${fluid(88, 160)};

  &[data-bg-colour='light'] {
    --bgColour: ${brand.global.beige};
    --contentColour: ${brand.blue.navy};
  }

  &[data-theme=${ContentType.Savings}] {
    --stepColour: ${brand.blue.default};
  }

  &[data-theme=${ContentType.Intermediaries}] {
    --stepColour: ${brand.blue.navy};
  }

  // Changed to dark green for accessibility (contrast failed for default green)
  &[data-bg-colour='light'][data-theme=${ContentType.Default}] {
    --stepColour: ${brand.green.dark};
  }

  &[data-bg-colour='dark'][data-theme=${ContentType.Intermediaries}] {
    --stepColour: ${brand.green.light};
  }

  &[data-alignment='centre'] {
    text-align: center;
  }
`;
const ContentWrapper = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: ${fluid(16, 24)} ${fluid(16, 16)} ${fluid(51, 51)};

  ${Container}:not(:has(img)) &,
  ${Container}:not(:has(svg)) & {
    flex: 0 1 auto;
  }
`;
const Count = styled.span `
  ${h2};
  margin-bottom: 6px;
  color: var(--stepColour);
`;
const ContentArea = styled.div `
  flex: 1 0 auto;
`;
const Heading = styled.h3 `
  ${h5};

  margin-bottom: ${fluid(16, 22)};
`;
const Description = styled.div `
  ${contentStyles};

  margin: 0;

    ul,
    ol {
      color: var(--contentColour);
    }
`;
const FlowchartCardStyles = {
    Container,
    ContentArea,
    ContentWrapper,
    Count,
    Heading,
    Description,
};
export default FlowchartCardStyles;
